import { useEffect } from 'react';
import type { Scope } from '../scopes';
import { SCOPES } from '../scopes';

interface Props {
  open: boolean;
  currentScope: Scope | null;
  onSelect: (scope: Scope) => void;
  onClose: () => void;
}

export function MoveScopeDialog({ open, currentScope, onSelect, onClose }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="dialog-overlay"
      role="dialog"
      aria-modal="true"
      aria-label="Move to scope"
      onClick={onClose}
    >
      <div className="move-scope-dialog" onClick={(e) => e.stopPropagation()}>
        <h3>Move to…</h3>
        <ul>
          {SCOPES.map((s) => (
            <li key={s.id}>
              <button
                onClick={() => {
                  onSelect(s.id);
                  onClose();
                }}
                disabled={s.id === currentScope}
                className="move-scope-option"
              >
                <span className="scope-swatch" style={{ backgroundColor: s.color }} />
                <span>{s.label}</span>
                {s.id === currentScope && <span className="muted small">current</span>}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
